import { render, staticRenderFns } from "./widget-event-card.vue?vue&type=template&id=86ce5f06"
import script from "./widget-event-card.vue?vue&type=script&lang=ts"
export * from "./widget-event-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports